import styled from "styled-components";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import {
  EmailOutlined,
  Instagram,
  Phone,
  RoomOutlined,
  Twitter,
} from "@mui/icons-material";
import { Link } from "react-router-dom";

const Container = styled.div`
  display: flex;
  background-color: #000638;
  color: white;
  @media (max-width: 768px) {
    flex-direction: column;
    font-size: 10px;
    box-sizing: border-box;
  }
`;
const Left = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const Logo = styled.h1``;

const Description = styled.div`
  margin: 20px 0px;
  @media (max-width: 768px) {
    margin: 10px 0px;
  }
`;

const SocialIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 15px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
`;

const SocialContainer = styled.div`
  display: flex;
`;

const Center = styled.div`
  flex: 1;
  padding: 20px;
  @media (max-width: 768px) {
    display: none;
  }
`;

const Title = styled.h3`
  margin-bottom: 30px;
`;
const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
`;
const LisItem = styled.li`
  width: 50%;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    margin-bottom: 5px;
  }
`;

const Right = styled.div`
  flex: 1;
  padding: 20px;
`;

const ContactItem = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;
const Payment = styled.img`
  height: 100px;
  width: 70%;
`;

const Footer = () => {
  return (
    <Container>
      <Left>
        <Logo>E-MART.</Logo>
        <Description>
          Welcome to Emart, your go-to fashion destination. Shop our affordable
          and trendy selection of clothing, shoes, and accessories. Our
          user-friendly interface and fast shipping make shopping a breeze.
          Elevate your style game with Emart - shop now!
        </Description>
        <SocialContainer>
          <SocialIcon style={{ backgroundColor: "#132fc1" }}>
            <FacebookOutlinedIcon />
          </SocialIcon>
          <SocialIcon style={{ backgroundColor: "#ff006c" }}>
            <Instagram />
          </SocialIcon>
          <SocialIcon style={{ backgroundColor: "#25b0ff" }}>
            <Twitter />
          </SocialIcon>
        </SocialContainer>
      </Left>
      <Center></Center>
      <Right>
        <Title>Contact</Title>
        <ContactItem>
          <RoomOutlined style={{ marginRight: "10px" }} />
          Durgapur-713215, West Bengal, India.
        </ContactItem>
        <ContactItem>
          <Phone style={{ marginRight: "10px" }} /> +91-9836361678
        </ContactItem>
        <ContactItem>
          <EmailOutlined style={{ marginRight: "10px" }} /> contact@emart.com
        </ContactItem>
        {/* <Payment src={Amex}/> */}
      </Right>
    </Container>
  );
};

export default Footer;
